// src/CourseForm.js
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from '../../scoring/store/MetaStore'
import CourseView from '../views/CourseView'

function CourseAdminController() {
  const [searchParams] = useSearchParams()
  const courseId = searchParams.get('courseId')
  const [courseData, setCourseData] = useState({
    courseName: '',
    slope: 0,
    rating: 0,
    fromDb: false,
    courseHoles: Array(9).fill({
      courseId: 0,
      holeNum: 0,
      holePar: 0,
      holeHcp: 0,
      holeYdsA: 0,
      holeYdsB: 0,
      holeYdsC: 0,
      holeYdsD: 0,
      fromDb: false,
    }),
  })
  const setGlobalModal = useMetaStore((state) => state.setGlobalModal)
  const navigate = useNavigate()

  useEffect(() => {
    // Fetch course data from the API when the component mounts
    if (courseId) {
      apiClient.get(`/gskapi/courses/find/${courseId}`)
        .then((response) => {
          setCourseData(response.data)
        })
        .catch((error) => {
          console.error('Error fetching course data:', error)
          initCourseHoles()
        })
    } else {
      initCourseHoles()
    }
  }, [])

  const initCourseHoles = () => {
    let num = 0
    for (let h of courseData.courseHoles) {
      h.holeNum = ++num
      courseData.courseHoles[num - 1] = { ...h }
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'courseName' || name === 'slope' || name === 'rating') {
      setCourseData({ ...courseData, [name]: value })
    } else {
      // Handle hole data changes
      const [holeIndex, fieldName] = name.split('-')
      const updatedHoles = [...courseData.courseHoles]
      updatedHoles[holeIndex][fieldName] = value
      setCourseData({ ...courseData, courseHoles: updatedHoles })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const res = await apiClient.post('/gskapi/courses/save', courseData)
      if (res.status === 200 || res.status === 201) {
        setGlobalModal(true, 'Save Successful', '#060')
        navigate('/admin/courses')
      } else {
        setGlobalModal(true, 'Failed to save course data.', '#900')
      }
    } catch (error) {
      console.error('Error saving course data:', error)
      setGlobalModal(true, 'Error saving course data.', '#900')
    }
  }

  const handleCancel = () => {
    navigate(-1)
  }

  const handleDelete = () => {
    // Implement the logic to delete the course
    apiClient
      .post(`/gskapi/courses/delete`, { courseId: courseId })
      .then((res) => {
        if (res.status === 200) {
          navigate('/admin/courses')
        } else {
          console.error(`Error deleting course: status ${res.status}`)
        }
      })
  }

  return (
    <CourseView
      courseData={courseData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      handleDelete={handleDelete}
    />
  )
}

export default CourseAdminController
